import React, { useContext } from 'react';
import classNames from 'classnames';
import Intl from '@fx-ui/intl';
import { getJobs, isPersonaFieldAvailable, map } from '~/utils';
import { PersonaInfo } from '~/interfaces';
import PersonaContext from '../../context/persona';
import PersonaCollectItem from '../persona-collect-item';

/**
 * 你的角色
 */
const Role = () => {
    const { personaInfo, setPersonaInfo, personaLabel } = useContext(PersonaContext);
    const { role } = personaInfo || {};

    const changeRole = (item: PersonaInfo['role']) => {
        let itemVal: PersonaInfo['role'] = { value: '', text: '' };
        let hasChosenRole = false;
        if (item?.value !== role?.value) {
            itemVal = item;
            hasChosenRole = true;
        }
        setPersonaInfo({
            hasChosenRole,
            role: itemVal
        });
    };

    if (!isPersonaFieldAvailable(personaLabel, 'job')) {
        return null;
    }

    return (
        <PersonaCollectItem className="fx-persona-role" title={Intl.get('role.your')}>
            {map(getJobs(personaLabel || []), (item) => (
                <div
                    key={item.value}
                    className={classNames('select-item', {
                        select: item.value === role?.value
                    })}
                    onClick={() => changeRole(item)}
                >
                    <div className="item-info">{item.text}</div>
                </div>
            ))}
        </PersonaCollectItem>
    );
};

export default Role;
